import { render, staticRenderFns } from "./AuthOther.vue?vue&type=template&id=0f34cd71&scoped=true"
import script from "./AuthOther.vue?vue&type=script&lang=js"
export * from "./AuthOther.vue?vue&type=script&lang=js"
import style0 from "./AuthOther.vue?vue&type=style&index=0&id=0f34cd71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f34cd71",
  null
  
)

export default component.exports